import styled, { css } from 'styled-components';
import { StyledIcon } from '../Icon/Icon';
import { fullPageModalTokens } from '../../tokens/components/FullPageModal/tokens';

const fixedFullSize = css`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;

export const FullPageModalWrapper = styled.div`
  ${fixedFullSize}
  z-index: ${fullPageModalTokens.CoreElevationZindexWrapper};

  ${({ theme }) =>
    theme.fullPageModalSlider &&
    css`
      .ink-slider {
        padding-top: 0;

        &--header--toggle__ghost {
          height: 100%;
        }
      }
    `}
`;

export const FullPageModalHeader = styled.div`
  background-color: ${fullPageModalTokens.CoreBackgroundColor};
  border-bottom: ${fullPageModalTokens.CoreBorderHeader};
  max-height: ${fullPageModalTokens.CoreSizeHeader};
  min-height: ${fullPageModalTokens.CoreSizeHeader};
  padding: 12px 20px;
  position: relative;
  width: ${fullPageModalTokens.CoreSizeFull};
  z-index: ${fullPageModalTokens.CoreElevationZindexHeader};
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) =>
    theme.fullPageModalSlider &&
    css`
      border-bottom: none;
      box-shadow: ${fullPageModalTokens.CoreElevationShadow};
    `}
`;

export const FullPageModalHeaderActionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FullPageModalHeaderActions = styled.div``;

export const FullPageModalHeaderClose = styled.div`
  ${FullPageModalHeaderActions}:not(:empty) + & {
    border-left: ${fullPageModalTokens.CoreBorderActions};
    padding-left: 16px;
    margin-left: 20px;
  }

  ${StyledIcon} svg {
    transition-duration: 60ms;
    transition-property: all;
    transition-timing-function: ease-in;
    transform-origin: center;
  }

  &:hover {
    text-decoration: none;

    ${StyledIcon} svg {
      backface-visibility: hidden;
      color: ${fullPageModalTokens.CoreIconColor};
      perspective: 1000;
      text-decoration: none;
      transform: scale(1.2);
      will-change: auto;
    }
  }
`;

export const FullPageModalContent = styled.div`
  background-color: ${fullPageModalTokens.CoreBackgroundColor};
  display: flex;
  height: ${fullPageModalTokens.CoreSizeFull};
  overflow: hidden;
  position: relative;
  z-index: ${fullPageModalTokens.CoreElevationZindexContent};
`;

export const FullPageModalContentChildren = styled.div`
  max-height: calc(${fullPageModalTokens.CoreSizeFull} - ${fullPageModalTokens.CoreSizeHeader});
  overflow-y: auto;
  padding-top: ${fullPageModalTokens.CoreSpacingContentVertical};
  position: relative;
  width: ${fullPageModalTokens.CoreSizeFull};
  ${({ theme }) =>
    theme.fullPageModalTrim &&
    css`
      padding-top: 0;
    `}

  ${({ theme }) =>
    theme.fullPageModalSlider &&
    css`
      position: relative;
      width: calc(${fullPageModalTokens.CoreSizeFull} - 60px);
    `}
`;

export const FullPageModalBackdrop = styled.div`
  ${fixedFullSize};
  pointer-events: none;
  z-index: ${fullPageModalTokens.CoreElevationZindexBackdrop};
`;
